<template>
	<div class="call-container">
		<div class="call-description card-body">
			<h2 class="h2-title">Описание вызовов</h2>
			<div>
				<div class="article-item" :style="`border-color: ${item.color}`" v-for="(item, i) in data" :key="i">
					<div class="article">
						<h3 class="h3-title"><span style="color: var(--black-40)">{{item.mark * 10}}%</span>
							{{item.title}}</h3>
						<p class="article-description" v-html="item.description">
						</p>
						<a :href="`https://edu.proektoria.online/dashboard/challenges/${item.id}`" target="_blank" class="link-underscore">Образовательный трек</a>
					</div>
				</div>
			</div>
		</div>
		<div class="call-description-banner">
			<h4 class="call-description-banner-title">Построй свой образовательный трек</h4>
			<p class="call-description-banner-description">Понравились материалы и профессии из разных вызовов? Сохрани
				их себе в трек! Так полезная информация точно не потеряется.</p>
		</div>
	</div>
</template>

<style lang="css">
	.call-container {
		display: flex;
		align-items: flex-start;
		flex-direction: row;
	}

	.call-description {
		flex: 1;
	}

	.call-description-banner {
		position: sticky;
		top: 16px;
		background-color: #fff;
		padding: 22px 12px;
		margin-left: 16px;
		flex: 0 0 200px;
		margin-bottom: 16px;
	}

	.call-description-banner-title {
		font-weight: bold;
		font-size: 16px;
		line-height: 20px;
		color: var(--black-90);
		opacity: 0.8;
		margin-bottom: 12px;
	}

	.call-description-banner-description {
		font-size: 12px;
		line-height: 120%;
		color: var(--black-80);
		opacity: 0.8;
	}

	/*Test description*/
	.article-item {
		padding-left: 16px;
		border-left: 16px solid;
		margin-bottom: 32px;
	}

	.article-item:last-child {
		margin-bottom: 0;
	}

	.article-description {
		font-size: 14px;
		line-height: 140%;
		color: var(--black-80);
		margin-bottom: 16px;
	}

	@media (max-width: 992px) {
		.call-container {
			flex-direction: column-reverse;
		}

		.call-description-banner {
			position: relative;
			margin-bottom: 16px;
			flex: 1;
			margin-left: 0;
			top: 0;
		}
	}
</style>

<script>
	export default {
		props: {
			data: {
				type: Array,
				default: () => {
					return []
				},
				required: true
			}
		}
	}
</script>
